<template>
  <v-card class="pa-8" elevation="5">
    <v-card-title>
      <span class="headline font-weight-bold">Opendock Nova Quickstart Guide</span>
    </v-card-title>
    <v-card-text class="text-h6">
      <step-item :step="steps.one">
        <v-row v-if="hasOrg" class="is-flex">
          <v-icon class="mr-2" large color="success">mdi-checkbox-marked-circle</v-icon>
          <span class="text-h5">Done!</span>
        </v-row>
        <div v-else>
          <create-org-dialog></create-org-dialog>
        </div>
      </step-item>

      <step-item class="mt-12" :step="steps.two"></step-item>
      <step-item class="mt-12" :step="steps.three"></step-item>
      <step-item class="mt-12" :step="steps.four"></step-item>
      <step-item class="mt-12" :step="steps.five"></step-item>
      <step-item class="mt-12" :step="steps.six"></step-item>
      <step-item class="mt-12" :step="steps.seven"></step-item>
    </v-card-text>
  </v-card>
</template>

<script>
import step2 from '@/../public/images/getting_started_steps/step2.jpg';
import step3 from '@/../public/images/getting_started_steps/step3.jpg';
import step4 from '@/../public/images/getting_started_steps/step4.jpg';
import step5 from '@/../public/images/getting_started_steps/step5.jpg';
import step6 from '@/../public/images/getting_started_steps/step6.jpg';
import step7 from '@/../public/images/getting_started_steps/step7.jpg';

export default {
  computed: {
    hasOrg() {
      return this.$me && this.$me.orgId;
    }
  },
  data() {
    return {
      steps: {
        one: {
          number: 1,
          step: 'Create your organization',
          description: 'This will be your Company Name'
        },
        two: {
          number: 2,
          step: 'Create your load types',
          description:
            'The load type is what dictates the duration of an appointment' +
            '<p class="pl-8 pt-2">' +
            '<span class="d-block">Think about the best way to categorize your appointment types and how long on average they usually take to complete.</span>' +
            '<span class="d-block"><span class="font-weight-bold">For example: </span>You may want to categorize by equipment type ' +
            '(i.e. Van, Dry, Reefer, Bulk, Flatbed, Tanker, LTL, FTL, etc.). LTL loads may only take 15 minutes, but FTL might take up to 90 minutes.</span>' +
            '</p>',
          htmlDescription: true,
          img: step2
        },
        three: {
          number: 3,
          step: 'Create a warehouse',
          description: 'This will be your individual warehouse locations',
          img: step3
        },
        four: {
          number: 4,
          step: 'Configure hours of operations',
          description: "This will be your location's hours",
          img: step4
        },
        five: {
          number: 5,
          step: 'Setup Dock Doors',
          description: this.buildListHtml([
            'Name the dock',
            'Assign one or more load types for your dock door',
            'Add a schedule if it’s more restrictive than the location’s schedule'
          ]),
          htmlDescription: true,
          img: step5
        },
        six: {
          number: 6,
          step: 'Invite Users',
          description: this.buildListHtml([
            'The new user will receive a confirmation email',
            'They will also receive a password recent email to create their password'
          ]),
          htmlDescription: true,
          img: step6
        },
        seven: {
          number: 7,
          step: 'Schedule Appointments!',
          description: this.buildListHtml([
            'Click on the grid',
            'Or click the “Add Appointment” button'
          ]),
          htmlDescription: true,
          img: step7
        }
      }
    };
  },
  methods: {
    buildListHtml(listArray) {
      let listHtml = '';
      listArray.map((item, index) => {
        let itemClasses = 'pl-4 d-block';
        if (!index) {
          itemClasses += ' pt-2';
        }
        listHtml += `<span class="${itemClasses}">- ${item}</span>`;
      });

      return listHtml;
    }
  }
};
</script>
